<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Dialysis Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisType"
              disabled
              label="Dialysis Type"
              :class="{ highlightField: isDifferent(dialysisType, dialysisTypeOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisTypeOATS"
              disabled
              class="dialysisType"
              label="Dialysis Type"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisAccessMode"
              disabled
              label="Dialysis Access Mode"
              :class="{ highlightField: isDifferent(dialysisAccessMode, dialysisAccessModeOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisAccessModeOATS"
              disabled
              label="Dialysis Access Mode"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisLocation"
              disabled
              label="Dialysis Location"
              :class="{ highlightField: isDifferent(dialysisLocation, dialysisLocationOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisLocationOATS"
              disabled
              label="Dialysis Location"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="otherDialysisLocation"
              disabled
              label="Other Dialysis Location"
              :class="{ highlightField: isDifferent(otherDialysisLocation, otherDialysisLocationOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="otherDialysisLocationOATS"
              disabled
              label="Other Dialysis Location"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisProvider"
              disabled
              label="Dialysis Provider"
              :class="{ highlightField: isDifferent(dialysisProvider, dialysisProviderOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisProviderOATS"
              class="dialysisProvider"
              disabled
              label="Dialysis Provider"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisStartDate"
              disabled
              label="Dialysis Start Date"
              :class="{ highlightField: isDifferent(dialysisStartDate, dialysisStartDateOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisStartDateOATS"
              disabled
              label="Dialysis Start Date"
            />
          </div>
        </div>


        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisEndDate"
              disabled
              label="Dialysis End Date"
              :class="{ highlightField: isDifferent(dialysisEndDate, dialysisEndDateOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="dialysisEndDateOATS"
              disabled
              label="Dialysis End Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import _ from 'lodash';
  import { DIALYSIS_PROVIDER_OATS_LABELS } from '../constants/dialysisProviderOATSLabels.js';
  
  const DIALYSIS_TYPE_OATS_LABELS = {
    '1': 'Frequent Nocturnal Dialysis',
    '2': 'Conventional Hemodialysis',
    '3': 'Home Intermittent Dialysis',
    '4': 'Home Short Hour Daily Hemodialysis',
    '5': 'Continuous Ambulatory Peritoneal Dialysis (CAPD)',
    '6': 'Automated Peritoneal Dialysis (APD)',
    '7': 'Other/Unknown',
  };
  
  const DIALYSIS_ACCESS_MODE_OATS_LABELS = {
    '1': 'Arteriovenous Fistula (AVF)',
    '2': 'Arteriovenous Graft',
    '3': 'Central Venous Catheter',
    '4': 'Body Access for Peritoneal Dialysis',
    '5': 'Other',
  };
  
  const DIALYSIS_LOCATION_OATS_LABELS = {
    '1': 'Hospital',
    '2': 'Home',
    '3': 'Satellite',
    '4': 'Other',
  };
  
  export default {
    name: "DialysisSectionDetailsEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        dialysisType: this.getDialysisType( this.patientBundle ),
        dialysisTypeOATS: this.getDialysisTypeOATS( this.patientBundleOATS ),
        dialysisAccessMode: this.getDialysisAccessMode( this.patientBundle ),
        dialysisAccessModeOATS: this.getDialysisAccessModeOATS( this.patientBundleOATS ),
        dialysisLocation: this.getDialysisLocation( this.patientBundle ),
        dialysisLocationOATS: this.getDialysisLocationOATS( this.patientBundleOATS ),
        otherDialysisLocation: this.getOtherDialysisLocation( this.patientBundle ),
        otherDialysisLocationOATS: this.getOtherDialysisLocationOATS( this.patientBundleOATS ),
        dialysisProvider: this.getDialysisProvider( this.patientBundle ),
        dialysisProviderOATS: this.getDialysisProviderOATS( this.patientBundleOATS ),
        dialysisStartDate: this.getDialysisStartDate( this.patientBundle ),
        dialysisStartDateOATS: this.getDialysisStartDateOATS( this.patientBundleOATS ),
        dialysisEndDate: this.getDialysisEndDate( this.patientBundle ),
        dialysisEndDateOATS: this.getDialysisEndDateOATS( this.patientBundleOATS ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
        const entries = patientBundle?.entries;
        if( !entries?.length ) {
          return null;
        }
        const smartdataGroups = entries.filter( ( n ) =>
          _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
        );
        const group = smartdataGroups[0];
        if( !group ) {
          return null;
        }
        const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
        _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if( !match[0] ) {
          return null;
        }
        const raw = _.get( match[0], `resource.component[0].${valuePath}` );
        if( raw === null || raw === undefined ) {
          return null;
        }
        return String( raw );
      },
      getDialysisType( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#177' ) ) ;
      if( dialysisType && dialysisType[ 0 ] ) {
        return _.get( dialysisType[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getDialysisTypeOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        const code = latestEntry?.dialysis_type_code;
        if( code === null || code === undefined || code === '' ) {
          return '';
        }
        const key = String( code ).trim();
        return DIALYSIS_TYPE_OATS_LABELS[ key ] ?? '';
      },
      getDialysisAccessMode( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisAccessMode = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#178' ) ) ;
      if( dialysisAccessMode && dialysisAccessMode[ 0 ] ) {
        return _.get( dialysisAccessMode[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getDialysisAccessModeOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        const code = latestEntry?.access_method_code;
        if( code === null || code === undefined || code === '' ) {
          return '';
        }
        const key = String( code ).trim();
        return DIALYSIS_ACCESS_MODE_OATS_LABELS[ key ] ?? '';
      },
      getDialysisLocation( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisLocation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#179' ) ) ;
      if( dialysisLocation && dialysisLocation[ 0 ] ) {
        return _.get( dialysisLocation[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getDialysisLocationOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        const code = latestEntry?.location_type_code;
        if( code === null || code === undefined || code === '' ) {
          return '';
        }
        const key = String( code ).trim();
        return DIALYSIS_LOCATION_OATS_LABELS[ key ] ?? '';
      },
      getOtherDialysisLocation( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisLocation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#180' ) ) ;
      if( dialysisLocation && dialysisLocation[ 0 ] ) {
        return _.get( dialysisLocation[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getOtherDialysisLocationOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        return latestEntry?.other_location_desc ?? '';
      },
      getDialysisProvider( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisProvider = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#207' ) ) ;
      if( dialysisProvider && dialysisProvider[ 0 ] ) {
        return _.get( dialysisProvider[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getDialysisProviderOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        const code = latestEntry?.dialysis_provider_code;
        if( code === null || code === undefined || code === '' ) {
          return '';
        }
        const key = String( code ).trim();
        return DIALYSIS_PROVIDER_OATS_LABELS[ key ] ?? '';
      },
      getDialysisStartDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#330' ) ) ;
      if( dialysisStartDate && dialysisStartDate[ 0 ] ) {
        return _.get( dialysisStartDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
      },
      getDialysisStartDateOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        return latestEntry?.start_date ?? '';
      },
      getDialysisEndDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#331' ) ) ;
      if( dialysisEndDate && dialysisEndDate[ 0 ] ) {
        return _.get( dialysisEndDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getDialysisEndDateOATS( patientBundleOATS ) {
        const procedures = patientBundleOATS?.dialysis_procedures;
        if( !procedures?.length ) {
          return '';
        }
        const latestEntry = [ ...procedures ].sort(
          ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at )
        )[ 0 ];
        return latestEntry?.end_date ?? '';
      },
      isDifferent( a, b ) {
        return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
    },
    },
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 330px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 850px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    padding-top: 5px;
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  :deep(.dialysisType .afflo-ds-form-control) {
    width: 400px;
  } 
  
  :deep(.dialysisProvider .afflo-ds-form-control) {
    width: 400px;
  } 
  
  .highlightField :deep(.afflo-ds-form-control) {
    border: 2px solid red;
  }
  
  </style>
  